import { render, staticRenderFns } from "./PuntoVentaFisico.vue?vue&type=template&id=15d2e454&scoped=true"
import script from "./PuntoVentaFisico.vue?vue&type=script&lang=js"
export * from "./PuntoVentaFisico.vue?vue&type=script&lang=js"
import style0 from "./PuntoVentaFisico.vue?vue&type=style&index=0&id=15d2e454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d2e454",
  null
  
)

export default component.exports